import type { PageTourDefinition, PageTourStep } from '../../components/tour/pageTourTypes';
import { ROUTES } from '../routes';

/** Pasos del tour en el listado `/ventas/facturas`. */
const FACTURAS_LISTADO_STEPS: PageTourStep[] = [
  {
    targetId: 'facturas-nueva-pos',
    title: 'Nueva factura POS',
    body: 'Desde acá abrís el punto de venta para emitir una factura: elegís cliente, cargás artículos y emitís el comprobante.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'facturas-filtros',
    title: 'Filtros de búsqueda',
    body: 'Filtrá por número, cliente, CUIT, estado de CAE, rango de fechas o sucursal para encontrar comprobantes rápido.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'facturas-kpis',
    title: 'Resumen del período',
    body: 'Estos indicadores resumen cantidad, totales, peso y volumen de las facturas según los filtros aplicados.',
    placement: 'bottom',
    pad: 4,
  },
  {
    targetId: 'facturas-grilla',
    title: 'Listado de facturas',
    body: 'Acá ves las facturas emitidas. Tocá el comprobante para abrirla en el POS en modo consulta.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'facturas-acciones',
    title: 'Acciones por factura',
    body: 'Desde cada fila podés obtener CAE, generar remito, imprimir o usar el menú ⋮ para editar, notas, anular, mail y más.',
    placement: 'left',
    pad: 6,
  },
];

/** Pasos del tour en el POS `/ventas/facturas/pos`. */
const FACTURAS_POS_STEPS: PageTourStep[] = [
  {
    targetId: 'pos-cliente',
    title: 'Cliente',
    body: 'Seleccioná el cliente de la factura. Desde el panel también podés repetir el último pedido, copiar facturas recientes o ver Info 360.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-busqueda',
    title: 'Artículos',
    body: 'Buscá y agregá productos a la factura. Con “Buscar pendientes” cargás entregas pendientes del cliente.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-lineas',
    title: 'Líneas de la factura',
    body: 'Editá cantidades, precios y descuentos de cada renglón. Podés duplicar o eliminar líneas según necesites.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'pos-totales',
    title: 'Totales y datos del comprobante',
    body: 'Revisá descuentos, IVA y total. Completá fechas, compañía, vendedor, lista de precios y datos de entrega.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'pos-emitir',
    title: 'Emitir factura',
    body: 'Cuando esté todo listo, emití la factura. Si el cobro está habilitado, podés emitir y cobrar en el mismo paso.',
    placement: 'top',
    pad: 8,
  },
];

export const FACTURAS_LISTADO_TOUR: PageTourDefinition = {
  id: 'facturas-listado',
  steps: FACTURAS_LISTADO_STEPS,
  continueTo: `${ROUTES.ventas.facturas.pos}?tour=1`,
  continueLabel: 'Ir al POS',
  continuePermiso: 'ventas.facturas.nuevo',
};

export const FACTURAS_POS_TOUR: PageTourDefinition = { id: 'facturas-pos', steps: FACTURAS_POS_STEPS };
